<template>
      <div fluid fill-height>
        <v-expand-x-transition>
          <landing-toolbar />
        </v-expand-x-transition>
        <v-container style="min-width:100% !important">
          <Operators />
        </v-container>
      </div>
</template>
    
    <script>
   import Operators from '../../components/Definiciones/Operadores/Operators.vue';
    import LandingToolbar from '../../components/LandingToolbar/LandingToolbar.vue'
    export default {
      components: { Operators, LandingToolbar },
    };
    </script>
    